<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.58752 12.9998L9.48752 15.8998C9.67086 16.0831 9.76252 16.3165 9.76252 16.5998C9.76252 16.8831 9.67086 17.1165 9.48752 17.2998C9.30419 17.4831 9.07086 17.5748 8.78752 17.5748C8.50419 17.5748 8.27086 17.4831 8.08752 17.2998L3.48752 12.6998C3.38752 12.5998 3.31669 12.4915 3.27502 12.3748C3.23336 12.2581 3.21252 12.1331 3.21252 11.9998C3.21252 11.8665 3.23336 11.7415 3.27502 11.6248C3.31669 11.5081 3.38752 11.3998 3.48752 11.2998L8.08752 6.6998C8.27086 6.51647 8.50419 6.4248 8.78752 6.4248C9.07086 6.4248 9.30419 6.51647 9.48752 6.6998C9.67086 6.88314 9.76252 7.11647 9.76252 7.3998C9.76252 7.68314 9.67086 7.91647 9.48752 8.0998L6.58752 10.9998H18.7875V7.9998C18.7875 7.71647 18.8834 7.47897 19.075 7.2873C19.2667 7.09564 19.5042 6.9998 19.7875 6.9998C20.0709 6.9998 20.3084 7.09564 20.5 7.2873C20.6917 7.47897 20.7875 7.71647 20.7875 7.9998V10.9998C20.7875 11.5498 20.5917 12.0206 20.2 12.4123C19.8084 12.804 19.3375 12.9998 18.7875 12.9998H6.58752Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#5C5957",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
